export const COOKIE_FIXTER_SEGMENT = 'fixterSegment';
